/* Decoaura room parfum — PDP, quick add, bundle, videos */
(function () {
  'use strict';
  if (window.__rpInit) return; window.__rpInit = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var CART_ADD = ROOT + 'cart/add.js';
  var CART_URL = ROOT + 'cart';

  function money(cents, currency) {
    try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency || 'INR', minimumFractionDigits: 0, maximumFractionDigits: cents % 100 === 0 ? 0 : 2 }).format(cents / 100); }
    catch (e) { return '₹' + (cents / 100).toLocaleString('en-IN'); }
  }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function addItems(items, url) {
    // preferred: the shared helper (theme-native: adds, refreshes and opens the cart drawer)
    if (window.decoauraCart) return window.decoauraCart.add(items);
    return fetch(url || CART_ADD, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); });
  }

  /* The helper already opened the drawer; only fall back to the cart page without it. */
  function openCart() {
    if (window.decoauraCart) return;
    window.location.href = CART_URL;
  }

  /* Quick add (mood cards) and bundle buttons */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-rp-quick]');
    var b = e.target.closest('[data-rp-bundle]');
    if (!q && !b) return;
    var btn = q || b;
    var ids = (q ? q.getAttribute('data-rp-quick') : b.getAttribute('data-rp-bundle')).split(',');
    var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = '…';
    var err = btn.parentNode.querySelector('[data-rp-err]');
    if (err) err.textContent = '';
    addItems(items).then(function () {
      btn.disabled = false; btn.textContent = label;
      openCart();
    }).catch(function (ex) {
      btn.disabled = false; btn.textContent = label;
      if (err) err.textContent = ex.message; else alertless(btn, ex.message);
    });
  });
  function alertless(el, msg) { el.setAttribute('title', msg); }

  /* Cross sell: next arrow (delegated once; was inside initPdp, which could bind it twice) */
  document.addEventListener('click', function (e) {
    var n = e.target.closest('[data-rp-xs-next]');
    if (!n) return;
    var t = n.parentNode.querySelector('[data-rp-xs-track]');
    if (!t) return;
    var atEnd = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
    t.scrollBy({ left: atEnd ? -t.scrollWidth : t.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* PDP */
  function initPdp(root) {
    var jsonEl = root.querySelector('[data-rp-json]');
    if (!jsonEl) return;
    var data; try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variant = data.variants.filter(function (v) { return v.id === data.current; })[0] || data.variants[0];
    var qty = 1;
    var qtyEl = root.querySelector('[data-rp-qty]');
    var err = root.querySelector('[data-rp-err]');
    var adds = $$(root, '[data-rp-add]');
    var buyNow = root.querySelector('[data-rp-buynow]');
    var addon = root.querySelector('[data-rp-addon]');

    /* gallery */
    var track = root.querySelector('[data-rp-track]');
    var slides = track ? $$(track, 'figure') : [];
    var dotsEl = root.querySelector('[data-rp-dots]');
    var thumbs = $$(root, '[data-rp-thumbs] button');
    var dots = [];
    if (dotsEl && slides.length > 1) {
      slides.forEach(function (_, i) {
        var d = document.createElement('button'); d.type = 'button';
        d.setAttribute('aria-label', 'View image ' + (i + 1));
        d.addEventListener('click', function () { go(i); });
        dotsEl.appendChild(d); dots.push(d);
      });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    function go(i) { if (track) track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
    function mark() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      dots.concat(thumbs).forEach(function (d) { d.removeAttribute('aria-current'); });
      if (dots[i]) dots[i].setAttribute('aria-current', 'true');
      if (thumbs[i]) thumbs[i].setAttribute('aria-current', 'true');
    }
    if (track) { track.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true }); mark(); }
    function goMedia(id) { for (var i = 0; i < slides.length; i++) if (String(slides[i].getAttribute('data-media-id')) === String(id)) { go(i); return; } }

    /* options */
    var sets = $$(root, '[data-rp-option]');
    function pick() {
      if (!sets.length) return;
      var chosen = sets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      var m = data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0];
      if (!m) return;
      variant = m;
      if (m.media) goMedia(m.media);
      try { var u = new URL(location.href); u.searchParams.set('variant', m.id); history.replaceState({}, '', u.toString()); } catch (e) {}
      render();
    }
    sets.forEach(function (fs) { fs.addEventListener('change', function () { syncRows(); pick(); }); });

    /* Card rows replace the fragrance option buttons: rows drive the (hidden) option */
    var rows = $$(root, '[data-rp-frag]');
    var fragSet = null;
    function nz(x) { return String(x || '').trim().toLowerCase(); }
    if (rows.length) {
      // the option whose values match the row names (works whatever it is called, even if misspelled)
      var rnames = rows.map(function (r) { return nz(r.value); });
      var best = 0;
      sets.forEach(function (fs) {
        var hits = $$(fs, 'input[type="radio"]').filter(function (r) { return rnames.indexOf(nz(r.value)) > -1; }).length;
        if (hits > best) { best = hits; fragSet = fs; }
      });
      if (fragSet) { fragSet.hidden = true; fragSet.style.display = 'none'; }
    }
    function markRows() { rows.forEach(function (r) { var l = r.closest('label'); if (l) l.classList.toggle('is-on', r.checked); }); }
    function syncRows() { // option -> rows
      if (!fragSet) return;
      var cur = fragSet.querySelector('input:checked');
      if (!cur) return;
      rows.forEach(function (r) { r.checked = nz(r.value) === nz(cur.value); });
      markRows();
    }
    rows.forEach(function (r) {
      r.addEventListener('change', function () { // row -> option
        if (fragSet) {
          var m = $$(fragSet, 'input[type="radio"]').filter(function (o) { return nz(o.value) === nz(r.value); })[0];
          if (m) m.checked = true;
        }
        markRows();
        pick();
      });
    });
    syncRows();

    function render() {
      var has = variant.compare > variant.price;
      $$(root, '[data-rp-price]').forEach(function (el) { el.textContent = money(variant.price, data.currency); });
      $$(root, '[data-rp-compare]').forEach(function (el) { el.hidden = !has; if (has) el.textContent = money(variant.compare, data.currency); });
      $$(root, '[data-rp-save]').forEach(function (el) {
        el.hidden = !has;
        if (has) { var s = variant.compare - variant.price; el.textContent = 'Save ' + money(s, data.currency) + ' (' + Math.round(s * 100 / variant.compare) + '%)'; }
      });
      $$(root, '[data-rp-sticky-price]').forEach(function (el) {
        el.innerHTML = money(variant.price, data.currency) + (has ? ' &nbsp;<s>' + money(variant.compare, data.currency) + '</s>' : '');
      });
      adds.forEach(function (b) { if (b.classList.contains('is-busy')) return; b.disabled = !variant.available; b.textContent = variant.available ? data.atcLabel : 'Sold out'; });
      if (buyNow) buyNow.disabled = !variant.available;
    }

    /* qty */
    $$(root, '[data-rp-q]').forEach(function (b) {
      b.addEventListener('click', function () { qty = Math.max(1, qty + parseInt(b.getAttribute('data-rp-q'), 10)); if (qtyEl) qtyEl.textContent = qty; });
    });

    function items() {
      var list = [{ id: variant.id, quantity: qty }];
      if (addon && addon.checked && data.addonVariant && data.addonAvailable) list.push({ id: data.addonVariant, quantity: 1 });
      return list;
    }
    function busy(on) {
      adds.concat(buyNow ? [buyNow] : []).forEach(function (b) { b.classList.toggle('is-busy', on); b.disabled = on || !variant.available; });
    }
    /* useDrawer = true: stay on the page and open the cart drawer.
       useDrawer = false: go to dest (used by Buy now -> checkout). */
    function submit(dest, useDrawer) {
      if (!variant.available) return;
      if (err) err.textContent = '';
      busy(true);
      addItems(items(), data.addUrl).then(function () {
        if (useDrawer) { busy(false); render(); openCart(); }
        else { window.location.href = dest; }
      }).catch(function (ex) { busy(false); render(); if (err) err.textContent = ex.message; });
    }
    adds.forEach(function (b) { b.addEventListener('click', function () { submit(data.cartUrl, true); }); });
    if (buyNow) buyNow.addEventListener('click', function () { submit('/checkout', false); });

    /* pincode: date range estimate from the section's day settings */
    var pinBtn = root.querySelector('[data-rp-pinbtn]');
    if (pinBtn) {
      var pin = root.querySelector('[data-rp-pin]');
      var out = root.querySelector('[data-rp-pinout]');
      function check() {
        var v = (pin.value || '').replace(/\D/g, '');
        out.hidden = false;
        if (v.length !== 6) { out.style.color = '#8C3B2E'; out.textContent = 'Enter a 6-digit pincode.'; return; }
        var f = { weekday: 'short', day: 'numeric', month: 'short' };
        var a = new Date(Date.now() + data.minDays * 864e5).toLocaleDateString('en-IN', f);
        var z = new Date(Date.now() + data.maxDays * 864e5).toLocaleDateString('en-IN', f);
        out.style.color = '#3F6B4B';
        out.textContent = 'Estimated delivery to ' + v + ': ' + a + ' – ' + z + (data.shipText ? ' · ' + data.shipText : '');
      }
      pinBtn.addEventListener('click', check);
      pin.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
    }

    /* sticky bar */
    var sticky = root.querySelector('[data-rp-sticky]');
    var main = root.querySelector('.rp-qtyrow');
    if (sticky && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        var sb = sticky.querySelector('button'); if (sb) sb.tabIndex = on ? 0 : -1;
      }).observe(main);
    }
    render();
  }

  /* UGC videos: play muted only while on screen */
  function initVideos(scope) {
    var vids = $$(scope, '.rp-ugc video');
    if (!vids.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { var v = x.target; if (x.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } });
      }, { threshold: 0.4 });
      vids.forEach(function (v) { io.observe(v); });
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rp-unmute]');
    if (!b) return;
    var v = b.parentNode.querySelector('video');
    if (!v) return;
    v.muted = !v.muted; b.textContent = v.muted ? 'Sound' : 'Mute'; b.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute');
    if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  });

  function boot(scope) {
    scope = scope || document;
    $$(scope, '[data-rp-pdp]').forEach(function (el) { if (!el.__rp) { el.__rp = true; initPdp(el); } });
    initVideos(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();